import React from "react";
import { Modal, Button } from "react-bootstrap";
import { XCircleFill } from "react-bootstrap-icons";
let wilburk = true;
const ModalD = ({ modalData, show, handleClose, compatible, handleClick }) => {
  const ListCompatible = () =>
    compatible.map((item) => (
      <p
        className="compButton"
        onClick={() => {
          handleClick(item);
        }}
      >
        {item.Modello}
      </p>
    ));

  const ImageUrl =
    "http://www.sir-autoparts.com/application-catalog/images/0210005.jpg";

  return (
    <>
      <Modal
        show={show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title>
            {modalData?.Descrizione} -{" "}
            {!wilburk ? modalData?.Codice : modalData?.WILBURK}
          </Modal.Title>
          <XCircleFill size={40} className="ml-4" onClick={handleClose} />{" "}
        </Modal.Header>
        <Modal.Body>
          <div className="modalInternal">
            <div>
              <img
                style={{
                  border: "solid #f1f1f1",
                  borderRadius: "0.5em",
                  marginBottom: "1em",
                }}
                alt={!wilburk ? modalData?.Codice : modalData?.WILBURK}
                src={
                  !wilburk
                    ? "https://www.nordicjones.com/wp-content/immagini-sir/" +
                      modalData?.Codice +
                      ".jpg"
                    : "https://www.nordicjones.com/wp-content/immagini-wilburk/" +
                      modalData?.WILBURK +
                      ".jpg"
                }
              />
              <p>
                <strong>Reference</strong> :{" "}
                {!wilburk ? modalData?.Codice : modalData?.WILBURK}
              </p>
              <p>
                <strong>Brand</strong> : {modalData?.Casa}{" "}
              </p>
              <p>
                <strong>Model</strong> : {modalData?.Modello}
              </p>
              <p>
                <strong>Side</strong> : {modalData?.Posizione}
              </p>
              <p>
                <strong>Description</strong> : {modalData?.Descrizione}
              </p>
            </div>
            <div>
              <div
                style={{
                  background: "#f1f1f1",
                  padding: "1em",
                  borderRadius: "0.5em",
                  marginBottom: "2em",
                }}
              >
                {/* <p style={{ marginBottom: "1em" }}>
                <strong>Competitors References</strong> :{" "}
              </p>

              {modalData?.AYD ? (
                <p>
                  <strong>AYD</strong> : {modalData?.AYD}
                </p>
              ) : null}
              {modalData?.BIRq ? (
                <p>
                  <strong>BIRp</strong> : {modalData?.BIRq}
                </p>
              ) : null}
              {modalData?.DELPHI ? (
                <p>
                  <strong>DELPHI</strong> : {modalData?.DELPHI}
                </p>
              ) : null}
              {modalData?.DYS ? (
                <p>
                  <strong>DYS</strong> : {modalData?.DYS}
                </p>
              ) : null}

              {modalData?.FEBI ? (
                <p>
                  <strong>FEBI</strong> : {modalData?.FEBI}
                </p>
              ) : null}
              {modalData?.FRAP ? (
                <p>
                  <strong>FRAP</strong> : {modalData?.FRAP}
                </p>
              ) : null}
              {modalData?.IR ? (
                <p>
                  <strong>IR</strong> : {modalData?.IR}
                </p>
              ) : null}
              {modalData?.MB ? (
                <p>
                  <strong>MB</strong> : {modalData?.MB}
                </p>
              ) : null}
              {modalData?.MOOG ? (
                <p>
                  <strong>MOOG</strong> : {modalData?.MOOG}
                </p>
              ) : null}

              {modalData?.OCAP ? (
                <p>
                  <strong>OCAP</strong> : {modalData?.OCAP}
                </p>
              ) : null} */}
                {modalData?.OE ? (
                  <p>
                    <strong>O.E. References</strong> :<br /> {modalData?.OE}
                  </p>
                ) : null}
                {/* {modalData?.OP ? (
                <p>
                  <strong>OP</strong> : {modalData?.OP}
                </p>
              ) : null}

              {modalData?.QH ? (
                <p>
                  <strong>QH</strong> : {modalData?.QH}
                </p>
              ) : null}
              {modalData?.RUVILLE ? (
                <p>RUVILLE : {modalData?.RUVILLE}</p>
              ) : null}
              {modalData?.SIDEM ? (
                <p>
                  <strong>SIDEM</strong> : {modalData?.SIDEM}
                </p>
              ) : null}
              {modalData?.TALOSA ? (
                <p>
                  <strong>TALOSA</strong> : {modalData?.TALOSA}
                </p>
              ) : null}
              {modalData?.TRW ? (
                <p>
                  <strong>TRW</strong> : {modalData?.TRW}
                </p>
              ) : null}
              {modalData?.VEMA ? (
                <p>
                  <strong>VEMA</strong> : {modalData?.VEMA}
                </p>
              ) : null}
              {!wilburk && modalData?.WILBURK ? (
                <p>
                  <strong>WILBURK</strong> : {modalData?.WILBURK}
                </p>
              ) : null}
              {wilburk && modalData?.Codice ? (
                <p>
                  <strong>SIR</strong> : {modalData?.Codice}
                </p>
              ) : null} */}
              </div>

              <div
                style={{
                  background: "#f1f1f1",
                  padding: "1em",
                  borderRadius: "0.5em",
                }}
              >
                <p>
                  <strong>Notes:</strong> <br></br>
                  {modalData?.Note}
                </p>
              </div>
            </div>
            <div>
              <div
                style={{
                  background: "#f1f1f1",
                  padding: "1em",
                  borderRadius: "0.5em",
                  marginBottom: "2em",
                }}
              >
                <p>
                  <strong>Adaptable to: </strong>
                </p>
                <ListCompatible />
              </div>
            </div>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};
export default ModalD;
